<template>
  <button :class="mode" :style="styles">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: ['mode'],
  data() {
    return {
      currentRoute: null,
      currentPath: null,
      isBusiness: false,
    };
  },
  watch: {
    currentRoute() {
      this.currentPath = this.currentRoute.path;
      this.currentQuery = this.currentRoute.query.page;
      if (this.currentPath.toLowerCase().indexOf('fchq') >= 0) {
        this.isBusiness = true;
      }
      if(this.currentRoute.query.page === 'meeting-rooms' && this.currentPath.toLowerCase().indexOf('whitlam') >= 0 ||
      this.currentRoute.query.page === 'community-spaces' && this.currentPath.toLowerCase().indexOf('whitlam') >= 0 ||
      this.currentRoute.query.page === 'creative-studio' && this.currentPath.toLowerCase().indexOf('whitlam') >= 0) {
        this.isBusiness = true;
      }
      if (this.currentPath.toLowerCase().indexOf('futsal') >= 0 || this.currentPath.toLowerCase().indexOf('tennis') >= 0) {
        this.isBusiness = false;
      } else {
        //     console.log('No.01');
      }
    },
  },

  computed: {
    styles: function () {
      if (this.isBusiness === true && this.mode == null) {
        //    console.log('this button ', this.isBusiness);
        return {
          'background-color': '#d5641c',
        };
      } else if (this.isBusiness === false && this.mode == null) {
        //  console.log('this button ', this.isBusiness);
        return {
          'background-color': '#00509e',
        };
      } else {
        return {
          'background-color': 'transparent',
        };
      }
    },
  },
  beforeMount() {
    this.currentRoute = this.$router.currentRoute;
    //  console.log(' current host', location.host);
  },
};
</script>
<style scoped>
button {
  width: 100%;
  padding: 0.75rem 1.5rem;
  /* font-family: inherit; */
  border: 1px solid #fff;
  background-color: #00509e;

  color: white;
  cursor: pointer;
}

@media (min-width: 768px) {
  button {
    width: auto;
  }
}

button:hover {
  background-color: #77b4e6cb;
  border-color: rgb(0, 0, 0);
}

button:active {
  background-color: #001c41;
}

.flat {
  background-color: transparent;
  color: #000;
  border: none;
}

.flat:hover,
.flat:active {
  background-color: #cbe1fd;
}
</style>
